export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Our Services</h2>
          <p>
          Net Wave Global provide a smart Services for all your worldwide projects including infrastructure services, installations, maintenance & warranty, IT support, and resourcing. Our infrastructure empowers us to deliver multi-technology services. 24/7 Helpdesk Support combined with quality self-assurance and excellent SLA loyalty.
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-3' style={{padding:"1% 1% 1% 3", height:"350px"}}>
                  {' '}
                  <i className={d.icon}> </i>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
